import axios from "../config/axios-config";
/* eslint-disable import/prefer-default-export */

const fetchParentSubs = async (data, token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  const response = await axios.post("/api/hms/gtmh/sub/search", data);
  const responseData = await response.data;
  return { results: responseData };
};

const createParent = async (data, token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  const response = await axios.post("/api/hms/gtmh/sub/create/parent", data);
  const responseData = await response.data;
  return { results: responseData };
};

const createSub = async (data, token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  const response = await axios.post("/api/hms/gtmh/sub/create/sub", data);
  const responseData = await response.data;
  return { results: responseData };
};

const searchParents = async (data, token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  const response = await axios.post("/api/hms/gtmh/sub/search/parents", data);
  const responseData = await response.data;
  return { results: responseData };
};

const updateSub = async (data, token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  const response = await axios.post("/api/hms/gtmh/sub/update", data);
  const responseData = await response.data;
  return { results: responseData };
};

const promoteSub = async (data, token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  const response = await axios.post("/api/hms/gtmh/sub/promote", data);
  const responseData = await response.data;
  return { results: responseData };
};

const demoteSub = async (data, token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  const response = await axios.post("/api/hms/gtmh/sub/demote", data);
  const responseData = await response.data;
  return { results: responseData };
};

const approveSub = async (data, token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  const response = await axios.post("/api/hms/gtmh/sub/approve", data);
  const responseData = await response.data;
  return { results: responseData };
};

const rejectSub = async (data, token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  const response = await axios.post("/api/hms/gtmh/sub/reject", data);
  const responseData = await response.data;
  return { results: responseData };
};

const deleteSub = async (data, token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  const response = await axios.post("/api/hms/gtmh/sub/deletesub", data);
  const responseData = await response.data;
  return { results: responseData };
};

const deleteParent = async (data, token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  const response = await axios.post("/api/hms/gtmh/sub/deleteparent", data);
  const responseData = await response.data;
  return { results: responseData };
};

export const gtmhApi = {
  fetchParentSubs,
  createParent,
  createSub,
  searchParents,
  updateSub,
  promoteSub,
  demoteSub,
  approveSub,
  rejectSub,
  deleteSub,
  deleteParent,
};
